import { getUserAttribute } from './data';
import Plat from 'utils/plat';
import _ from 'lodash';
class Volcengine {
  constructor(options) {
    const appId = Plat.isMiniProgram() ? process.env.VUE_APP_VOLCENGINE_MP_APP_ID : process.env.VUE_APP_VOLCENGINE_APP_ID;
    let defaults = {
      id: _.toNumber(appId),
      key: 'collectEvent',
      domain: 'https://gator.volces.com'
    };
    let data = { $gio: null };
    let _options = { ...defaults, ...data };
    Object.keys(_options).forEach(key => {
      this[key] = _options[key];
    });
    this.initial();
  }
  initial() {
    this.preset(window, this.key);
    this.setScript(window, document, 'script', 'lf3-data.volccdn.com/obj/data-static/log-sdk/collect/5.0/collect-rangers-v5.1.12.js', this.key);
    window[this.key]('init', {
      app_id: this.id, // 参考2.1节获取，注意类型是number而非字符串
      channel_domain: this.domain, // 设置数据上送地址
      disable_sdk_monitor: true,
      autotrack: true,
      enable_stay_duration: true,
      enable_debug: window.location.hostname === 'localhost'
      // enable_debug: false
    });
    // 此处可添加设置uuid、设置公共属性等代码
    window[this.key]('start'); // 通知SDK设置完毕，可以真正开始发送事件了
  }
  setScript(e, t, n, g, i) {
    let tag;
    e[i] =
      e[i] ||
      function() {
        (e[i].q = e[i].q || []).push(arguments);
      };
    n = t.createElement('script');
    tag = t.getElementsByTagName('script')[0];
    n.async = 1;
    n.src = ('https:' === document.location.protocol ? 'https://' : 'http://') + g;
    tag.parentNode.insertBefore(n, tag);
  }
  preset(win, export_obj) {
    win['TeaAnalyticsObject'] = export_obj;
    if (!win[export_obj]) {
      var _collect = function() {
        _collect.q.push(arguments);
      };
      _collect.q = _collect.q || [];
      win[export_obj] = _collect;
    }
    win[export_obj].l = +new Date();
  }
  sendLogout() {
    window[this.key]('config', {
      user_unique_id: 'null'
    });
  }
  sendUserAttributes() {
    getUserAttribute().then(user => {
      if (user?.user_unique_id) {
        window[this.key]('config', {
          user_unique_id: user.user_unique_id
        });
      }
      window[this.key]('profileSet', user);
    });
  }
  sendEvent(event, payload) {
    let triggerPlatform = 'web';
    if (Plat.isMiniProgram()) {
      triggerPlatform = 'mp';
    } else if (Plat.isWeiXin()) {
      triggerPlatform = 'wx';
    }
    payload = Object.assign(payload, {
      trigger_route: window.location.pathname,
      trigger_platform: triggerPlatform
    });
    if (payload?.beacon) {
      window[this.key]('beconEvent', event, payload);
    } else {
      window[this.key](event, payload);
    }
  }
}
export default new Volcengine();
